import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('TransportationCostService', TransportationCostService);

  TransportationCostService.$inject = ['RestResource', '$translate', '$filter', 'UtilService'];

  function TransportationCostService(RestResource, $translate, $filter, UtilService) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'transportations';

    var service = {
      searchTransportationCosts: searchTransportationCosts,
      saveTransportationCosts: saveTransportationCosts,
      searchTransportationPickupCosts: searchTransportationPickupCosts,
      saveTransportationPickupCosts: saveTransportationPickupCosts,
    };

    return service;

    ////////////////

    function searchTransportationCosts(transportation, filterCriteria) {
      var url = apiUrl + '/' + transportation.id + '/transportation_costs';

      if (!filterCriteria) {
        filterCriteria = {};
      }

      filterCriteria.company_id = transportation.company_id;

      return RestResource.request(
        'get',
        url,
        filterCriteria,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveTransportationCosts(transportation, params, editMode) {
      var url = apiUrl + '/' + transportation.id + '/transportation_costs';

      params.company_id = transportation.company_id;
      params.option = !editMode ? 'create' : 'update';

      function success(response) {
        var msg = !editMode ? 'COSTS_ADDED' : 'UPDATED_COSTS';
        utils._successMsg($translate(msg));

        return response.data;
      }
      function failure(response) {
        utils.openModalError(response.data.error);

        return false;
      }

      return RestResource.request('post', url, params, success, failure);
    }

    function searchTransportationPickupCosts(transportation, filterCriteria) {
      var url = apiUrl + '/' + transportation.id + '/transportation_pickup_costs';

      if (!filterCriteria) {
        filterCriteria = {};
      }

      filterCriteria.company_id = transportation.company_id;

      return RestResource.request(
        'get',
        url,
        filterCriteria,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveTransportationPickupCosts(transportation, params, editMode) {
      var url = apiUrl + '/' + transportation.id + '/transportation_pickup_costs';

      params.company_id = transportation.company_id;
      params.option = !editMode ? 'create' : 'update';

      function success(response) {
        var msg = !editMode ? 'PICKUP_COSTS_ADDED' : 'PICKUP_COSTS_UPDATED';
        utils._successMsg($translate(msg));

        return response.data;
      }
      function failure(response) {
        utils.openModalError(response.data.error);

        return false;
      }

      return RestResource.request('post', url, params, success, failure);
    }
  }
})();
